import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";
import { Remove_empty_bins } from "../helper/remove_empty_bins";
import * as crossfilter from "crossfilter2/crossfilter";

const econStatusChartFunc = (divRef, ndx) => {
    const esi_finace_index = ndx.dimension((d) => d.esI_Settlement_type);

  //const esi_finace_index_grp = esi_finace_index.group().reduceSum((d) => d.esi);

    // custom reducer to  compute the averages
    const esi_finace_index_grp = esi_finace_index.group().reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
            ++p.count;
            p.tot += v.esi;
            p.avg += p.count ? p.tot / 47 : 0;
           
            return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
            --p.count;
            p.tot -= v.esi;
            p.avg -= p.count ? p.tot / 47 : 0; // hard code number of counties due to dublicates in data
           
            return p;
        },
        /* initialize p */
        function () {
            return { count: 0, tot: 0, avg: 0 };
        }
    );
    const esi = dc.rowChart(divRef);

    esi
        .width(250)
        .height(150)
        .elasticX(true)
        .dimension(esi_finace_index)
        .label((d) => d.key)
        .valueAccessor((d) => {
          return d.value["tot"] / d.value["count"]

        })

        .colors(d3.scaleOrdinal().domain([0, 1]).range(["#327E73"]))

        .group(Remove_empty_bins(esi_finace_index_grp, null))

        .margins({ top: 20, right: 20, bottom: 40, left: 70 })

        .gap(5)
        .cap(5)
        .title(function (d) {
            return (d.value["tot"] / d.value["count"]).toFixed(2);
        })
        .transitionDuration(1500);

    esi.labelOffsetX(-50);

    esi.xAxis().ticks(5)
  return esi;
};

export const EconomicStrengthIndexChart = (props) => (
  <ChartTemplate
    chartFunction={econStatusChartFunc}
    title="Financial Status (Economic Strength Index)"
  />
);
